import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class AddressVoted extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default AddressVoted
